(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchlineup/assets/javascripts/views/statmatchlineup.js') >= 0) return;  svs.modules.push('/components/statistics/matchlineup/assets/javascripts/views/statmatchlineup.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatMatchLineup = svs.statistics.views.SportserviceTabBase.extend(
    {
      classId: 'StatMatchLineup',

      initialize: function(options) {
        options = options || {};
        svs.statistics.views.SportserviceTabBase.prototype.initialize.apply(
          this,
          [options]
        );

        _.bindAll(this, 'renderError');

        if (!this.options.params.matchId) {
          return;
        }

        this.initModel(options);
        this.initTheme(options);

        if (
          svs.utils.ns.isNamespace(
            'statistics.data.matchModels.lineups',
            svs
          ) &&
          !svs.statistics.data.matchModels.lineups.error
        ) {
          if (!this.model.hasLineups()) {
            this.model.start();
          }
        } else {
          this.fetchModel();
        }
      },

      initModel: function(options) {
        this.model = new svs.statistics.models.statMatchLineup({
          urlParams: { id: options.params.matchId },
          leagueId: options.params.leagueId
        });

        this.listenTo(this.model, 'change', this.onModelChange);
      },

      fetchModel: function() {
        this.model.fetch({ error: this.renderError });
      },

      initTheme: function() {
        if (this.theme) {
          return;
        }

        var leagueId = this.model.get('leagueId')
            ? this.model.get('leagueId')
            : 0,
          sportId = this.model.get('sport') && this.model.get('sport').id;

        if (!sportId) {
          return;
        }

        this.theme = new svs.sport.themeLoader({
          league: leagueId,
          sport: sportId
        });
      },

      onModelChange: function() {
        if (!this.model.hasLineups()) {
          this.model.start();
        } else {
          this.model.stop();
        }

        this.render();
      },

      renderWithData: function() {
        if (!this.model || !this.model.hasTeams()) {
          return this.renderNoLineup();
        }

        this.model.sortStartersByPosition();

        this.initTheme();
        this.theme.load(
          function(template, init) {
            this.template = template;

            if (this.model.hasLineups()) {
              this.renderLineup(init);
            } else {
              this.renderRosters();
            }

            if (this.options.params.parent) {
              this.options.params.parent.trigger('resize');
            }
          }.bind(this),
          'stat-match-lineup'
        );

        return this;
      },

      renderLineup: function(init) {
        var templateData = _.extend(
          this.model.toJSON(),
          this.model.getFormationByPosition(init)
        );
        this.$el.html(this.template(templateData));

        return this;
      },

      renderRosters: function() {
        if (!this.model.hasTeams()) {
          return this.renderNoLineup();
        }

        var homeRoster = new svs.statistics.views.StatTeamPlayers({
            params: { teamId: this.model.get('homeTeam').id }
          }),
          awayRoster = new svs.statistics.views.StatTeamPlayers({
            params: { teamId: this.model.get('awayTeam').id }
          });

        this.$el.html(svs.statistics.matchlineup.templates.rosters({}));
        this.$el.find('.home-team-roster').html(homeRoster.el);
        this.$el.find('.away-team-roster').html(awayRoster.el);

        return this;
      },

      renderNoLineup: function() {
        this.$el.html(
          svs.statistics.statistics.templates.nodata({
            message: 'Ingen laguppställning är tillgänglig'
          })
        );

        return this;
      },

      renderError: function() {
        var self = this;

        this.$el.html(svs.statistics.statistics.templates.tryagain({}));

        this.$('.js-statistics-reload').on('click', function() {
          $(this).off('click');
          self.fetchModel();
        });

        return this;
      },

      themeFunction: function(func, data) {
        var returner;

        if (!this.theme) {
          return returner;
        }

        this.theme.load(function(template, init) {
          if (init) {
            returner = init(func, data);
          }
        }, 'init');

        return returner;
      },

      onDestroy: function() {
        delete this.options.params.parent;

        if (this.model && this.model.stop) {
          this.model.stop();
        }

        this.$el.empty();
        this.stopListening();
        this.off();
      }
    }
  );
})(Backbone, _, svs);

 })(window);